module.exports = __webpack_public_path__ + "static/media/cap-brazil.fe084a0e.png";